{
    "name": "Sinterklaas Raalte",
    "fullName": "Sinterklaas Raalte",
    "description": "De Sint en zijn Pieten zijn al jaren in Raalte en omgeving te gast bij de gezelligste Huisbezoeken, Bedrijf en Verenigingen feesten, Schoolbezoeken en Intochten!",
    "slogan": "Sinterklaas Raalte",
    "kvk_number": "08174269",
    "telephone": {
        "text": "(0572) 363603",
        "href": "0572363603"
    },
    "email": {
        "text": "huisbezoeken@sinterklaas-raalte.nl",
        "href": "huisbezoeken@sinterklaas-raalte.nl"
    }
}
